import React from 'react';
import {Badge} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

const UserStatusBadge = ({enabled}) => (
    <Badge color={enabled ? 'success' : 'danger'}>
        {enabled ? <FormattedMessage {...messages.admin.users.enabled} /> : <FormattedMessage {...messages.admin.users.disabled} />}
    </Badge>
);

export default UserStatusBadge;
